module.exports = __webpack_public_path__ + "static/media/transparencia.0c5c47a2.svg";